<template>
  <div class="cell">
    <div class="left">总共</div>
    <div class="right" v-if="!!rightText">{{ rightText }}</div>
  </div>
</template>

<script>
export default {
  props: {
    rightText: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.cell
  height pt(120)
  display flex
  justify-content space-between
  align-items center
  width 100%
  font-size $normal-font-size
  .left
    width 6em
    flex 0 1 auto
    text-align left
    color #888888
  .right
    flex 0 1 auto
    text-align right
    color $primary-color
    font-size $big-font-size

</style>




// WEBPACK FOOTER //
// item-total-price.vue?2fca7c3a